import { render, staticRenderFns } from "./InfoAnimated.vue?vue&type=template&id=2918d9dc&"
import script from "./InfoAnimated.vue?vue&type=script&lang=js&"
export * from "./InfoAnimated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports